import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          最新动态
        </h2>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="flex flex-col gap-4">
            {updatesData.map((item) => (
              <div key={item.id} className="flex items-start gap-4 relative">
                <span
                  className={`relative z-10 w-[38px] h-[38px] flex items-center justify-center rounded-full flex-shrink-0 text-xs font-medium ${
                    item.type === '更新'
                      ? 'bg-primary-100 text-primary-700'
                      : item.type === '专题'
                      ? 'bg-accent-100 text-accent-700'
                      : item.type === '榜单'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.date.slice(0, 2)}
                </span>
                <div className="flex-1 min-w-0 pt-1.5">
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium mb-1.5 whitespace-nowrap ${
                    item.type === '更新'
                      ? 'bg-primary-100/70 text-primary-700'
                      : item.type === '专题'
                      ? 'bg-accent-100/80 text-accent-700'
                      : item.type === '榜单'
                      ? 'bg-secondary-100/80 text-secondary-700'
                      : 'bg-background-200/70 text-foreground-600'
                  }`}>
                    {item.type}
                  </span>
                  <h3 className="text-sm text-foreground-800 leading-relaxed">{item.title}</h3>
                  <span className="text-xs text-foreground-500 mt-1 block">{item.tag} · {item.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}